module.exports = __webpack_public_path__ + "static/media/UploadImages.bb1ff651.gif";